import React, { useContext } from "react";

export type WidgetOptions = {
  headerRight: React.ReactNode;
  background: string | undefined;
};

const DEFAULT: WidgetOptions = {
  headerRight: null,
  background: undefined,
};

const Ctx = React.createContext<WidgetOptions>(DEFAULT);

export const WidgetOptionsProvider = Ctx.Provider;
export const useWidgetOptions = () => useContext(Ctx);
